import { render, staticRenderFns } from "./MealOrderDetail2.vue?vue&type=template&id=5ab4870a"
import script from "./MealOrderDetail2.vue?vue&type=script&lang=js"
export * from "./MealOrderDetail2.vue?vue&type=script&lang=js"
import style0 from "./MealOrderDetail2.vue?vue&type=style&index=0&id=5ab4870a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports